import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import Chart from '../../../charts/Chart';
import ForecastConfig from './ForecastConfig';
import { toZonedTime } from 'date-fns-tz';


function ForecastCharts(props) {
    const [showConfig, setShowConfig] = useState(false);
    const intl = useIntl()
    const chartsList = Array.isArray(props.charts) ? props.charts : [];

    function handleConfigurationButton() {
        setShowConfig(!showConfig)
    }

    const charts = chartsList.map((chart) => {
        let lastDates, maxChartDate;
        const chartGraphs = Array.isArray(chart.graphs) ? chart.graphs : [];
        if (chartGraphs.length > 0) {
            lastDates = chartGraphs.map(
                (graph) => graph.data.length > 0 ? graph.data[graph.data.length - 1][0] : null
            );
            if (lastDates.length > 0)
                maxChartDate = lastDates.reduce((p, v) => p > v ? p : v);
        }

        const chartTitle = `<div class="mdl-layout-spacer">
                                <b>${chart.name}</b>
                                <span style="font-size:.8em; font-weight:900; color:gray;">
                                    ${maxChartDate ? intl.formatDate(toZonedTime(maxChartDate, 'Etc/UTC'), { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }) : ''}
                                </span>
                            </div>`;
        return (
            <div
                key={chart.id}
                className='min-w-full lg:min-w-[50%] 2xl:min-w-[33%] pt-4'
            >
                <Chart
                    intl={intl}
                    graphs={chartGraphs}
                    key={chart.id}
                    name={chart.name}
                    maximized={true}
                    chartId={chart.id}
                    isForecast={true}
                    title={chartTitle}
                />
            </div>
        )
    })

    return <div className='p-0 sm:p-2 pt-2'>
        <div className="conf-btn-ctn p-4">
            <div></div>
            <div className="config-btn" onClick={handleConfigurationButton}>
                <i className="material-icons">settings</i>
                {
                    intl.formatMessage(
                        {
                            id: 'app.admin.forecast.configurations',
                            defaultMessage: 'CONFIGURATIONS'
                        }
                    )
                }
            </div>
        </div>

        <div className="flex flex-row flex-wrap ">
            {
                showConfig &&
                <ForecastConfig onClose={handleConfigurationButton} />
            }

            {
                chartsList.length > 0
                    ?
                    charts
                    :
                    <span className='text-slate-700 text-sm mx-auto'>
                        No ha activado el pronóstico del tiempo para ninguna estación
                    </span>
            }
        </div>
    </div>;
}

export default ForecastCharts;
